/* eslint-disable react-hooks/exhaustive-deps */
// import { message } from 'antd';
// import { useField } from 'formik';
// import React, { useRef, useState } from 'react';
// import { useSelector } from 'react-redux';
// import { AuthState } from '../../store/reducer/auth';

// type Props = {
//   name?: string; // Formik name (only needed when isForm=true)
//   isForm?: boolean; // connect to formik
//   styleContainer?: React.CSSProperties;
//   style?: React.CSSProperties;
// };

// export const ImageUpload = ({ name, isForm = false, styleContainer, style }: Props) => {
//   const [field] = useField(name);
//   const inputRef = useRef<HTMLInputElement | null>(null);
//   const [messageApi, contextHolder] = message.useMessage();
//   const { accessToken } = useSelector((state: { auth: AuthState }) => state.auth);

//   const [image, setImage] = useState<{
//     id?: string;
//     url?: string;
//   }>();

//   const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     try {
//       const res = await uploadFile(file);
//       messageApi.success('Амжилттай!');

//       console.log('set preview image', res.url);
//       // http://20.20.20.56:3050/pub/media/14fe8df3-0ff4-4c18-a27d-02e4a48c6a38/salon.webp

//       setImage(res);

//       // if (isForm)
//       //  formik.form.setFieldValue(name!, res.id);
//     } catch {
//       messageApi.error('Алдаа гарлаа');
//     }
//   };

//   const uploadFile = async (file: File) => {
//     const formData = new FormData();
//     formData.append('file', file);

//     const res = await fetch(`${process.env.REACT_APP_API_URL}/api/media/upload`, {
//       method: 'POST',
//       body: formData,
//       headers: { Authorization: `Bearer ${accessToken}` },
//     });

//     if (!res.ok) throw new Error('Upload error');

//     const data = await res.json();
//     console.log('wTF :', data, field.value);
//     return data; // imageId
//   };

//   React.useEffect(() => {
//     setImage(field.value);
//   }, [field.value]);

//   return (
//     <>
//       {contextHolder}
//       <div
//         style={styleContainer}
//         className="bg-[#F7F8FA] rounded-[24px] flex flex-col items-center justify-center p-[20px]"
//       >
//         <div
//           // onClick={() => inputRef.current?.click()}
//           style={style}
//           className="w-full h-[146px] rounded-[24px] border-dashed border-[1px] border-[#5869FF]
//             flex items-center justify-center cursor-pointer relative"
//         ></div>
//       </div>

//       <input
//         ref={inputRef}
//         type="file"
//         accept="image/*"
//         onChange={handleFileChange}
//         className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
//       />
//     </>
//   );
// };

// import React, { useRef, useState } from 'react';
// import { useSelector } from 'react-redux';
// import { Field, useField } from 'formik';
// import { AuthState } from '../../store/reducer/auth';
// import { message } from 'antd';

// type Props = {
//   name?: string; // Formik name (only needed when isForm=true)
//   isForm?: boolean; // connect to formik
//   styleContainer?: React.CSSProperties;
//   style?: React.CSSProperties;
// };

// const ImageUpload = ({ name, isForm = false, styleContainer, style }: Props) => {
//   const inputRef = useRef<HTMLInputElement | null>(null);
//   const [preview, setPreview] = useState<string | null>(null);
//   const { accessToken } = useSelector((state: { auth: AuthState }) => state.auth);
//   const [messageApi, contextHolder] = message.useMessage();

//   const [field] = useField(name);

//   React.useEffect(() => {
//     setPreview(field.value);
//   }, [field.value]);
//   // ************* UPLOAD FUNCTION *************
//   const uploadFile = async (file: File) => {
//     const formData = new FormData();
//     formData.append('file', file);

//     const res = await fetch(`${process.env.REACT_APP_API_URL}/api/media/upload`, {
//       method: 'POST',
//       body: formData,
//       headers: { Authorization: `Bearer ${accessToken}` },
//     });

//     if (!res.ok) throw new Error('Upload error');

//     const data = await res.json();
//     console.log('wTF :', data, field.value);
//     return data; // imageId
//   };

//   // ************* MAIN RENDER *************
//   const renderUpload = (formik?: any) => {
//     const formValue = isForm ? formik?.field?.value : undefined;

//     // console.log('formValue :', formValue);
//     // setPreview(formValue);

//     const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
//       const file = e.target.files?.[0];
//       if (!file) return;

//       // console.log('URL.createObjectURL(file) =>', URL.createObjectURL(file));
//       // console.log('URL.createObjectURL(file) =>', (file));

//       try {
//         const res = await uploadFile(file);
//         messageApi.success('Амжилттай!');

//         console.log('set preview image', res.url);
//         // http://20.20.20.56:3050/pub/media/14fe8df3-0ff4-4c18-a27d-02e4a48c6a38/salon.webp

//         setPreview(res.url);

//         if (isForm) formik.form.setFieldValue(name!, res.id);
//       } catch {
//         messageApi.error('Алдаа гарлаа');
//       }
//     };

//     const handleRemove = () => {
//       setPreview(null);
//       if (inputRef.current) inputRef.current.value = '';
//       if (isForm) formik.form.setFieldValue(name!, undefined);
//     };

//     return (
//       <div
//         style={styleContainer}
//         className="bg-[#F7F8FA] rounded-[24px] flex flex-col items-center justify-center p-[20px]"
//       >
//         <div
//           onClick={() => inputRef.current?.click()}
//           style={style}
//           className="w-full h-[146px] rounded-[24px] border-dashed border-[1px] border-[#5869FF]
//             flex items-center justify-center cursor-pointer relative"
//         >
//           {preview && (
//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleRemove();
//               }}
//               className="absolute top-2 right-2 w-7 h-7 rounded-full bg-black/50 text-white"
//             >
//               ✕
//             </button>
//           )}

//           {preview ? (
//             <img
//               src={preview}
//               alt="preview"
//               className="absolute inset-0 w-full h-full object-cover rounded-[16px]"
//             />
//           ) : (
//             <>
//               <svg
//                 width="124"
//                 height="109"
//                 viewBox="0 0 124 119"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <ellipse cx="59.5" cy="60" rx="55.5" ry="55.5" fill="#5869FF" fillOpacity="0.16" />
//                 <rect x="32.6" y="31.6" width="57" height="57" rx="103.5" fill="#5869FF" />
//                 <path
//                   d="M60.75 51.25C60.75 50.5596 60.1904 50 59.5 50C58.8096 50 58.25 50.5596 58.25 51.25V58.75H50.75C50.0596 58.75 49.5 59.3096 49.5 60C49.5 60.6904 50.0596 61.25 50.75 61.25H58.25V68.75C58.25 69.4404 58.8096 70 59.5 70C60.1904 70 60.75 69.4404 60.75 68.75V61.25H68.25C68.9404 61.25 69.5 60.6904 69.5 60C69.5 59.3096 68.9404 58.75 68.25 58.75H60.75V51.25Z"
//                   fill="white"
//                 />
//               </svg>
//             </>
//           )}

//           <input
//             ref={inputRef}
//             type="file"
//             accept="image/*"
//             onChange={handleFileChange}
//             className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
//           />
//         </div>
//       </div>
//     );
//   };

//   // ************* IF NOT FORM MODE *************
//   if (!isForm) {
//     return (
//       <>
//         {contextHolder}
//         {renderUpload()}
//       </>
//     );
//   }

//   // ************* FORM MODE (Formik Field) *************
//   return (
//     <>
//       {contextHolder}
//       <Field name={name}>{(formikProps: any) => renderUpload(formikProps)}</Field>
//     </>
//   );
// };

// export { ImageUpload };

// asd
// import React, { useRef, useState } from 'react';
// import { useSelector } from 'react-redux';
// import { AuthState } from '../../store/reducer/auth';
// import { message } from 'antd';

// type Props = {
//   styleContainer?: React.CSSProperties;
//   style?: React.CSSProperties;
//   onChange?: (file: File | null) => void;
//   uploadOnChange?: (url: string) => void;
//   uploadOnRemove?: () => void;
//   isForm?: boolean;
//   name?: string;
//   validateStatus?: 'success' | 'warning' | 'error' | 'validating' | '';
// };

// const ImageUpload = ({
//   styleContainer,
//   style,
//   onChange,
//   uploadOnChange,
//   uploadOnRemove,
//   validateStatus,
// }: Props) => {
//   const inputRef = useRef<HTMLInputElement | null>(null);
//   const [preview, setPreview] = useState<string | null>(null);
//   const { accessToken } = useSelector((state: { auth: AuthState }) => state?.auth);
//   const [messageApi, contextHolder] = message.useMessage();
//   const [loading, setLoading] = useState(false);

//   const handleClick = () => {
//     inputRef.current?.click();
//   };

//   const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     const url = URL.createObjectURL(file);
//     setPreview(url);
//     onChange?.(file);

//     try {
//       setLoading(true);
//       const formData = new FormData();
//       formData.append('file', file);

//       const res = await fetch(`${process.env.REACT_APP_API_URL}/api/media/upload`, {
//         method: 'POST',
//         body: formData,
//         headers: { Authorization: `Bearer ${accessToken}` },
//       });

//       if (res.ok) {
//         const data = await res.json();
//         console.log('upload image  :', data?.id);
//         uploadOnChange?.(data?.id);
//         messageApi.open({
//           type: 'success',
//           content: 'Амжилттай!',
//         });
//       } else {
//         setLoading(false);
//         messageApi.open({
//           type: 'error',
//           content: 'Алдаа гарлаа',
//         });
//       }
//     } catch (err) {
//       setLoading(false);
//       messageApi.open({
//         type: 'error',
//         content: 'Алдаа гарлаа',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // --- REMOVE IMAGE ---
//   const handleRemove = (e: React.MouseEvent) => {
//     e.stopPropagation(); // prevent re-opening upload dialog

//     setPreview(null);
//     if (inputRef.current) inputRef.current.value = ''; // reset input
//     onChange?.(null);
//     uploadOnRemove?.();
//   };

//   return (
//     <>
//       {contextHolder}
//       <div
//         style={styleContainer}
//         className="bg-[#F7F8FA] rounded-[24px] flex flex-col items-center justify-center p-[20px]"
//       >
//         <div
//           onClick={handleClick}
//           style={style}
//           // className="w-full h-[146px] rounded-[24px] opacity-100 flex pt-8 pr-[100px] pb-8 pl-[100px] border-dashed border-[1px] border-[#5869FF] [stroke-dasharray:2_2] flex-col items-center justify-center cursor-pointer relative"
//           className={`
//             w-full h-[146px] rounded-[24px] opacity-100 flex
//             pt-8 pr-[100px] pb-8 pl-[100px] border-dashed border-[1px]
//             ${validateStatus === 'error' ? 'border-red-500' : 'border-[#5869FF]'}
//             [stroke-dasharray:2_2] flex-col items-center justify-center cursor-pointer relative
//           `}
//         >
//           {/* REMOVE BUTTON */}
//           {preview && (
//             <button
//               onClick={handleRemove}
//               className="absolute top-2 right-2 w-7 h-7 rounded-full bg-black/50 text-white flex items-center justify-center text-sm hover:bg-black/70 z-20"
//             >
//               ✕
//             </button>
//           )}

//           {/* Preview */}
//           {preview ? (
//             <img
//               src={preview}
//               alt="preview"
//               className="absolute inset-0 w-full h-[146px] object-cover rounded-[16px]"
//             />
//           ) : (
//             <svg
//               width="154"
//               height="119"
//               viewBox="0 0 124 119"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <ellipse cx="59.5" cy="60" rx="55.5" ry="55.5" fill="#5869FF" fillOpacity="0.16" />
//               <rect x="32.6" y="31.6" width="57" height="57" rx="103.5" fill="#5869FF" />
//               <path
//                 d="M60.75 51.25C60.75 50.5596 60.1904 50 59.5 50C58.8096 50 58.25 50.5596 58.25 51.25V58.75H50.75C50.0596 58.75 49.5 59.3096 49.5 60C49.5 60.6904 50.0596 61.25 50.75 61.25H58.25V68.75C58.25 69.4404 58.8096 70 59.5 70C60.1904 70 60.75 69.4404 60.75 68.75V61.25H68.25C68.9404 61.25 69.5 60.6904 69.5 60C69.5 59.3096 68.9404 58.75 68.25 58.75H60.75V51.25Z"
//                 fill="white"
//               />
//             </svg>
//           )}

//           {/* Hidden input */}
//           <input
//             ref={inputRef}
//             type="file"
//             accept="image/*"
//             onChange={handleChange}
//             className="absolute inset-0 w-full h-full opacity-0 pointer-events-none"
//           />
//         </div>
//       </div>
//     </>
//   );
// };

// export { ImageUpload };

import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AuthState } from '../../store/reducer/auth';
import { message } from 'antd';

type Props = {
  styleContainer?: React.CSSProperties;
  style?: React.CSSProperties;
  onChange?: (file: File | null) => void;
  uploadOnChange?: (id: string) => void;
  uploadOnRemove?: () => void;
  validateStatus?: 'success' | 'warning' | 'error' | 'validating' | '';
  value?: string; // ⭐ NEW — гаднаас урьдчилсан зураг авах
};

const ImageUpload = ({
  styleContainer,
  style,
  onChange,
  uploadOnChange,
  uploadOnRemove,
  validateStatus,
  value: initialUrl,
}: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const { accessToken } = useSelector((state: { auth: AuthState }) => state?.auth);
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);

  // ⭐ Гаднаас ирсэн URL → preview дээр тавина
  useEffect(() => {
    if (initialUrl) {
      setPreview(initialUrl);
    }
  }, []);

  const handleClick = () => inputRef.current?.click();

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setPreview(URL.createObjectURL(file));
    onChange?.(file);

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('file', file);

      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/media/upload`, {
        method: 'POST',
        body: formData,
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (!res.ok) throw new Error();

      const data = await res.json();
      uploadOnChange?.(data.id);

      messageApi.success('Амжилттай!');
    } catch {
      messageApi.error('Алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    setPreview(null);
    if (inputRef.current) inputRef.current.value = '';
    uploadOnRemove?.();
    onChange?.(null);
  };

  return (
    <>
      {contextHolder}
      <div
        style={styleContainer}
        className="bg-[#F7F8FA] rounded-[24px] flex flex-col items-center justify-center p-[20px]"
      >
        <div
          onClick={handleClick}
          style={style}
          className={`
            w-full h-[146px] rounded-[24px] opacity-100 flex 
            pt-8 pr-[100px] pb-8 pl-[100px] border-dashed border-[1px]
            ${validateStatus === 'error' ? 'border-red-500' : 'border-[#5869FF]'}
            flex-col items-center justify-center cursor-pointer relative
          `}
        >
          {/* ❌ Remove button */}
          {preview && (
            <button
              onClick={handleRemove}
              className="absolute top-2 right-2 w-7 h-7 rounded-full bg-black/50 text-white z-20 hover:bg-black/70"
            >
              ✕
            </button>
          )}

          {/* ⭐ PREVIEW IMAGE */}
          {preview ? (
            <img
              src={preview}
              className="absolute inset-0 w-full h-full object-cover rounded-[16px]"
            />
          ) : (
            // Default icon
            <svg width="124" height="109" viewBox="0 0 124 119" fill="none">
              <ellipse cx="59.5" cy="60" rx="55.5" ry="55.5" fill="#5869FF" fillOpacity="0.16" />
              <rect x="32.6" y="31.6" width="57" height="57" rx="103.5" fill="#5869FF" />
              <path
                d="M60.75 51.25C60.75 50.5596 60.1904 50 59.5 50C58.8096 50 58.25 50.5596 58.25 51.25V58.75H50.75C50.0596 58.75 49.5 59.3096 49.5 60C49.5 60.6904 50.0596 61.25 50.75 61.25H58.25V68.75C58.25 69.4404 58.8096 70 59.5 70C60.1904 70 60.75 69.4404 60.75 68.75V61.25H68.25C68.9404 61.25 69.5 60.6904 69.5 60C69.5 59.3096 68.9404 58.75 68.25 58.75H60.75V51.25Z"
                fill="white"
              />
            </svg>
          )}

          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            onChange={handleChange}
            className="absolute inset-0 w-full h-full opacity-0 pointer-events-none"
          />
        </div>
      </div>
    </>
  );
};

export { ImageUpload };
